<template>
  <div class="cc_main" style="min-height: calc(100vh - 200px);">
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem to="/enjoy/discount">企业享惠查询 </BreadcrumbItem>
        <BreadcrumbItem>享惠分析详情 </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="s1 boxshadow1" >
      <div class="s1-title">
        <div class="ss1">享惠分析详情
      
        </div>

      </div>
      <div style="display: flex;">
        <div style="flex: 1;"> 
          <div class="s1-content">
          <div class="item">
            <div class="item-title">批次号：<span v-if="dataSet.batch">{{dataSet.batch}}</span><span v-else>-</span></div>
         
          </div>
          <div class="item">
            <div class="item-title">报关单号：<span v-if="dataSet.customsCode">{{dataSet.customsCode}}</span><span v-else>-</span></div>
        
          </div>
          <div class="item">
            <div class="item-title">进出口标志：<span v-if="dataSet.type">{{dataSet.type}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">申报日期：<span v-if="dataSet.declarationDate">{{dataSet.declarationDate}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">起运地：<span v-if="dataSet.exporter">{{dataSet.exporter}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">目的地：<span v-if="dataSet.importer">{{dataSet.importer}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">监管方式：<span v-if="dataSet.regulatedMode">{{dataSet.regulatedMode}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">成交方式：<span v-if="dataSet.transactionMode">{{dataSet.transactionMode}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">净重（KG）：<span v-if="dataSet.weightNet">{{dataSet.weightNet}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">毛重（KG）：<span v-if="dataSet.weightTotal">{{dataSet.weightTotal}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">运费（币制）：<span v-if="dataSet.freightFee">{{dataSet.freightFee}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">运费模式：<span v-if="dataSet.freightMode">{{dataSet.freightMode}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">保费（币制）：<span v-if="dataSet.insuranceFee">{{dataSet.insuranceFee}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">保费模式：<span v-if="dataSet.insuranceMode">{{dataSet.insuranceMode}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">杂费（币制）：<span v-if="dataSet.otherFee">{{dataSet.otherFee}}</span><span v-else>-</span></div>
  
          </div>
          <div class="item">
            <div class="item-title">杂费模式：<span v-if="dataSet.otherMode">{{dataSet.otherMode}}</span><span v-else>-</span></div>
  
          </div>
         
        </div>
        <div style="border-bottom:1px solid #bebebe"></div>
        <div class="s1-content">
          <div class="item">
            <div class="item-title" style="margin-bottom: 5px;">应税总金额 <Tooltip content="应税金额（小计）累加"><svg-icon icon-class="help" style="color: rgb(188, 140, 240);
    font-weight: 900;
    font-size: 18px;
    margin-left: 4px;"></svg-icon></Tooltip></div>
            <div class="item-value bc3">¥{{(dataSet.taxAmount || 0) | amountThousands}}</div>
          </div>
          <div class="item">
            <div class="item-title" style="margin-bottom: 5px;">理论可享惠税费总金额<Tooltip content="明细理论可享惠金额累加（最优）"><svg-icon icon-class="help" style="color: rgb(188, 140, 240);
    font-weight: 900;
    font-size: 18px;
    margin-left: 4px;"></svg-icon></Tooltip></div>
            {{ dataSet.benefitTotal }}
            <div class="item-value bc2">¥{{(dataSet.customsBenefit || 0) | amountThousands}}</div>
          </div>
          <div class="item">
            <div class="item-title" style="margin-bottom: 5px;">实际享惠税费总金额<Tooltip content="实际可享惠总金额  = 明细实际可享惠金额累加"><svg-icon icon-class="help" style="color: rgb(188, 140, 240);
    font-weight: 900;
    font-size: 18px;
    margin-left: 4px;"></svg-icon></Tooltip></div>
            <div class="item-value bc1">¥{{(dataSet.actualBenefit || 0) | amountThousands}}</div>
          </div>
          <div class="item timer" style="margin-right: -350px;">
            <div class="item-title" style="margin-bottom: 5px;">享惠分析时间</div>
            <div class="item-value" v-if="dataSet.benefitTime">
              {{dataSet.benefitTime }}
              <!-- <span class="btn1" @click.prevent="isShowMoreS1=!isShowMoreS1">{{isShowMoreS1 ? '收起' : '查看更多'}}</span> -->
            </div>
            <div class="item-value" v-else>-</div>
          </div>
        </div>
      
      </div>
      <div style="width: 300px;background-color: rgb(2, 167, 240); color: rgb(255, 255, 255); padding: 20px 10px; margin: 0px 0px 20px 20px; line-height:30px;font-size:16px">  <div >享惠说明</div>
      <p>系统将根据企业导入的进出口数据，自动分析是否可以享受协定优惠税率，并根据商品应税金额计算税金优惠金额</p>
    
    </div>
      
      </div>
      
   
    </div>

    <div class="s2 boxshadow1" v-for="(item,index) in dataSet2.result" :key="index">
      <div class="s2-header">
        <div class="breadcrumbs ellipsis" style="width: 95%;" >
          <Row :gutter="20"  style="justify-content: space-between;display:flex">
            <div span="12" style="width:50%"><Col span="12">商品编码：<span  style="color: #bc8cf0;">{{item.code}}</span></Col>     <Col span="6" >商品名称：
              <span style="color: #bc8cf0;">{{item.name}}</span></Col></div>
            <div span="12" style="flex: 1;
            display: flex;
            justify-content: end;">
            <span  style="margin-right: 20px;color:red" v-if="item.errorMsg"> 错误信息：<span class="bc2" style="    background: red">{{ item.errorMsg}}</span></span>
              <span  style="margin-right: 20px;"> 理论可享惠金额：<span class="bc2">¥{{(item.benefitTotal || 0) | amountThousands}}</span></span>
                <span span="10"  style="margin-right: 20px;">实际可享惠金额：<span class="bc1">¥{{(item.actualBenefitTotal || 0) | amountThousands}}</span></span>
                <span span="3" style="color:#a8730b">享惠机会：{{item.benefitStatus || '-'}}</span>
              </div>
          </Row>
        </div>
        <div class="opr">
         
          <div class="date">
            
            <Button size="small" type="primary" v-if="item.show" @click="dataSet2.result[index].show=false">
               折叠
        </Button>
        <Button size="small" type="primary" v-else @click="dataSet2.result[index].show=true">
          展开  
      </Button>
      
      </div>
        </div>
      </div>
      <div class="s2_wrap" style="padding:5px 18px 18px" v-if="dataSet2.result[index].show ">
        <div  style="border: 0.5px solid #bfdef1; padding: 10px; border-radius: 6px;margin-top: 15px;font-size:15px;color:#8b8989">
          <Row >
           <Col span="4">原产国：{{item.origin || '-'}}</Col>     
           <Col span="4">成交量（单位）：{{item.transactionCount || '-'}}</Col>
           <Col span="5">单价（币制）：{{item.unitPrice || '-'}}</Col>
           <Col span="5">总货值（币制）：{{item.totalAmount || '-'}}</Col>
           <Col span="4">享惠代码：{{item.benefitCode || '-'}}</Col>
           <Col span="4" >分摊运费<Tooltip > <svg-icon icon-class="help" style="color: rgb(188, 140, 240);
    font-weight: 900;
    font-size: 18px;
    margin-left: 4px;"></svg-icon>      <div slot="content">
            <p>分摊运费 = 总运费*(明细货值/明细总货值)</p>
            <p>模式=总价：总运费 = 运费转换为人民币</p>
            <p>模式=单价：总运费 = 运费 *（净重/1000）</p>
            <p>模式=费率：总运费 = 明细总金额 * 费率</p>
        </div></Tooltip>：{{item.freight || '-'}}</Col>
           <Col span="4">分摊保费<Tooltip > <svg-icon icon-class="help" style="color: rgb(188, 140, 240);
    font-weight: 900;
    font-size: 18px;
    margin-left: 4px;"></svg-icon>      <div slot="content">
            <p>分摊保费 = 总保费*(明细货值/明细总货值)</p>
            <p>模式=总价：总保费 = 保费转换为人民币</p>
            <p>模式=单价：总保费 = 保费 *（净重/1000）</p>
            <p>模式=费率：总保费 = ((货值+运费+杂费）/(1-保费费率)) * 保费费率</p>
        </div></Tooltip>：{{item.insurance || '-'}}</Col>
           <Col span="5">分摊杂费<Tooltip > <svg-icon icon-class="help" style="color: rgb(188, 140, 240);
    font-weight: 900;
    font-size: 18px;
    margin-left: 4px;"></svg-icon>      <div slot="content">
            <p>分摊杂费 = 总杂费*(明细货值/明细总货值)</p>
            <p>模式=总价：总杂费 = 杂费转换为人民币</p>
            <p>模式=单价：总杂费 = 杂费 *（净重/1000）</p>
            <p>模式=费率：总杂费 = 明细总金额 * 费率</p>
        </div></Tooltip>：{{item.other || '-'}}</Col>
           <Col span="5">海关汇率<Tooltip > <svg-icon icon-class="help" style="color: rgb(188, 140, 240);
    font-weight: 900;
    font-size: 18px;
    margin-left: 4px;"></svg-icon>      <div slot="content">
            <p>当前报关单申报日期和币制对应的汇率</p>
      
        </div></Tooltip>：{{item.exchange || '-'}}</Col>
           <Col span="5">应税金额（小计）<Tooltip > <svg-icon icon-class="help" style="color: rgb(188, 140, 240);
            font-weight: 900;
            font-size: 18px;
            margin-left: 4px;"></svg-icon>      <div slot="content">
                    <p>成交方式=CIF：应税金额（小计） = 明细货值*汇率+分摊杂费</p>
                    <p>成交方式=C&F： 应税金额（小计） = 明细货值*汇率+分摊保费+分摊杂费</p>
                    <p>成交方式=FOB：应税金额（小计） = 明细货值*汇率+分摊运费+分摊保费+分摊杂费</p>
                    <p>成交方式=EXW：应税金额（小计） = 明细货值*汇率+分摊运费+分摊保费+分摊杂费</p>
                    <p>成交方式=C&I： 应税金额（小计） = 明细货值*汇率+分摊运费+分摊杂费</p>
                </div></Tooltip>：<span class="bc3">¥{{(item.tax || 0) | amountThousands}}</span></Col>
          </Row>
        </div>
    
        <div v-if="!item.errorMsg"  style="padding: 10px;
        border-radius: 6px;
        margin-top: 15px;
        font-size: 15px;
        background: #eee;
        color: rgb(139, 137, 137);">
          <Row style="margin-right: 50px;">
           <Col span="6" offset="4"><span style="width:130px;display:inline-block">暂定税率：{{dataSet.taxProvisionalRate || '-'}}</span> <span style="display:inline-block">暂定税税金：{{dataSet.taxProvisional || '-'}}</span></Col>     
        
           <Col span="5">消费税率：{{dataSet.taxExciseRate || '-'}}</Col>
     
           <Col span="5">增值税率：{{dataSet.taxValueAddedRate || '-'}}</Col>
          </Row>
          <Row style="margin-top: 10px;margin-right: 50px;">
           <Col span="6" offset="4" ><span style="width:130px;display:inline-block">最惠国税率：{{dataSet.taxMfnRate || '-'}}</span> <span style="display:inline-block">最惠国税金：{{dataSet.taxMfn || '-'}}</span></Col>    
           <Col span="5">消费税税金（最惠国）：{{dataSet.taxExcise || '-'}}</Col>
           <Col span="5">增值税税金（最惠国）：{{dataSet.taxValueAdded || '-'}}</Col>
          
          </Row>
        </div>


        <div v-if="!item.errorMsg"  style="padding: 10px;
        border-radius: 6px;
        margin-top: 15px;
        font-size: 15px;
        background: #eee;
        color: rgb(139, 137, 137);    position: relative;" v-for="(item2,index2) in item.ftaList">
          <Row  style="margin-right: 50px;">
            <Col span="4" style="color: #bc8cf0;">{{item2.ftaName || '-'}}</Col>
 
           <Col span="6" ><span style="width:130px;display:inline-block">FTA税率：{{(item2.ftaTaxRate * 100).toFixed(2) + '%' || '-'}}</span> <span style="display:inline-block">FTA税金： ¥{{(item2.ftaTax || 0) | amountThousands}}</span></Col>     
        
     
           <Col span="5">消费税税金(协定)：¥{{(item2.taxExciseFta || 0) | amountThousands}}</Col>
           <Col span="5">增值税税金(协定)：¥{{(item2.taxValueAddedFta || 0) | amountThousands}}</Col>
           <Col span="4">小计</Col>
          </Row>
          <Row style="margin-top: 10px;
          color: rgb(2, 167, 240);
   
          font-size: 15px;
  
          margin-right: 50px;">
 
           <Col span="6" offset="4">理论可享关税金额：¥{{(item2.benefitTax || 0) | amountThousands}}</Col>     
        
     

           <Col span="5">理论可享消费税金额：¥{{(item2.benefitExcise || 0) | amountThousands}}</Col>
           <Col span="5">理论可享增值税金额：¥{{(item2.benefitValueAdd || 0) | amountThousands}}</Col>
           <Col span="4">理论可享惠金额：¥{{(item2.benefitTotal || 0) | amountThousands}}</Col>
          </Row>
          <Row style="margin-top: 10px;color:#a8730b;margin-right: 50px;">
 
            <Col span="6" offset="4">实际可享关税金额：¥{{(item2.actualBenefitTax || 0) | amountThousands}}</Col>     
         
      
 
            <Col span="5">实际可享消费税金额：¥{{(item2.actualBenefitExcise || 0) | amountThousands}}</Col>
            <Col span="5">实际可享增值税金额：¥{{(item2.actualBenefitValueAdd || 0) | amountThousands}}</Col>
            <Col span="4">实际可享惠金额：¥{{(item2.actualBenefitTotal || 0) | amountThousands}}</Col>
           </Row>
           <img src="~@/assets/images/zuiyou.png"  style="right: 1%;
           top: 33%;
           width: 60px;
           position: absolute;
         " v-if="parseInt(item2.best) === 1">
        </div>
      
      </div>
    
    </div>
    <div style="text-align: center;padding:20px">       <Page :total="dataSet.total" :current="currentPageNumber" :page-size="10" size="small" @on-change="getQueryList"></Page></div>

   
  </div>
</template>

<script>
export default {
  name: 'DiscountResultContent',
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    dataSet2: {
      type: Object,
      default: () => { return {} },
      required: false
    },
  },
  data () {
    return {
      currentPageNumber:1,
      isShowMoreS1: false
    }
  },
  created () {
   
    if (this.dataSet.benefitStatus || this.dataSet.benefitStatus === 0 || this.dataSet.benefitStatus === '0') {
      this.isShowMoreS1 = true
    }
  },
  methods: {
    getQueryList(page){
      this.currentPageNumber = page
        this.$emit('benefitDetailList',page)
    }
  }
}
</script>

<style scoped>
>>>.ivu-tooltip-inner{
  max-width:fit-content;
}
.s1{
  margin-bottom: 30px;
  margin-top: 15px;
  padding: 18px 18px 16px;
}
.s1-title{
  font-weight: bold;
  color: #323232;
  font-size: 15px;
  display: flex;
  align-items: center;
}
.ss1{
  display: flex;
  align-items: center;
}
.ss2{
  margin-left: 16px;
}
.ss2 span{
  background: url("~@/assets/images/coo/icon_tx.png") 0 center no-repeat transparent;
  background-size: 12px;
  padding-left: 18px;
  color: #f30d0d;
  font-size: 14px;
  font-weight: normal;
}
.s1-title .sstatus{
  color: #c5c4c4;
  font-size: 13px;
  padding-left: 20px;
  font-weight: normal;
}
.s1-title .sstatus span{
  background-color: #f37e6c;
  padding: 1px 12px;
  color: #fff;
  font-size: 14px;
  margin: 0 6px 0 5px;
  border-radius: 3px;
}
.s1-content{
  margin-top: 10px;
}
.ivu-breadcrumb{
  margin: 12px 0 30px;
  font-size: 15px;
}
.breadcrumb{
  width: 100%;
}
.s1-content .item{
  width: 24%;
  display: inline-block;

}
.s1-content .item.timer{
  width: 40%;
}
.s1-content .item.timer .item-value {
  display: flex;
  align-items: center;
}
.s1-content .item-title{
  color: #8b8989;
  margin-bottom: 15px;
  font-size: 15px;
}
.s1-content .item-value{
  font-size: 15px;
  position: relative;
}
.bc1{
  background-color: rgb(168, 115, 11);
  padding: 2px 8px;
  color: #fff;
  display: inline-block;
  border-radius: 3px;
}
.bc2{
  background-color: rgb(188, 140, 240);
  padding: 2px 8px;
  color: #fff;
  display: inline-block;
  border-radius: 3px;
}
.bc3{
  background-color: #ddd;
  padding: 2px 8px;
  color: #333;
  display: inline-block;
  border-radius: 3px;
}
.btn1{
  color: #fff;
  cursor: pointer;
  border: 1px solid #0774b5;
  background-color: #0774b5;
  padding: 3px 0;
  display: block;
  width: 100px;
  text-align: center;
  font-size: 14px;
  border-radius: 3px;
  margin-left: 20px;
}
.breadcrumbs{
  font-size: 14px;
  color: #333;
  padding: 14px 18px;
}
.breadcrumbs >>> span span{
  color: #fff;
  font-weight: bold;
  cursor: default;
}
.s2-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 18px;
  border-bottom: 0.5px solid #ccc;
}
.s2-header .opr{
  display: flex;
  align-items: center;
}
.s2-header .opr .title{
  color: #c5c4c4;
  font-size: 13px;
}
.s2-header .code {
  background-color: #f37e6c;
  padding: 1px 12px;
  color: #fff;
  font-size: 14px;
  margin: 0 6px 0 5px;
}
.s2-header .date{
  font-size: 14px;
}
.s3 .s2-header{
  font-size: 14px;
  color: #333;
  padding: 14px 18px;
}
.s3 .s2-header .left{
  display: flex;
  align-items: center;
}
.s3 .s2-header .left .f1,
.s3 .s2-header .left .f2,
.s3 .s2-header .left .f3{
  color: #b5b3b3;
  font-size: 13px;
}
.s3 .s2-header .left .f1,
.s3 .s2-header .left .f2{
  margin-right: 60px;
}
.s3 .s2-header .left .f1 span,
.s3 .s2-header .left .f2 span,
.s3 .s2-header .left .f3 span{
  color: #333;
  font-size: 14px;
  display: inline-block;
  margin-left: 16px;
  border: 0.5px solid #5a99da;
  padding: 0 6px;
  min-width: 60px;
  text-align: center;
  border-radius: 6px;
  color: #0470e3;
}
.s3 .s2-header .left .f3 span{
  background-color: #5a99da;
  color: #fff;
}
.besttax{
  background-color: #f5d82b;
  font-size: 12px;
  padding: 0 5px;
  border-radius: 3px;
  color: #000;
  display: inline-block;
  font-weight: normal;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Enjoy/ResultContent.vue